// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"549f5ff6","860":"4b3d5d2c","932":"4c034db7"}[chunkId] + ".chunk.js";
};